export default __webpack_public_path__ + "static/media/pse.242437b6.png";